import React from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormInput from "../common/FormInput";
import FormSelect from "../common/FormSelect";

const schema = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  dateOfBirth: yup.date().required("Date of Birth is required"),
  gender: yup.string().required("Gender is required"),
  phoneNumber: yup.string().required("Phone Number is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  address1: yup.string().required("Address Line 1 is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  zipCode: yup.string().required("Zip Code is required"),
  employeeId: yup.string().required("Employee ID is required"),
  licenseNumber: yup.string().required("License Number is required"),
  licenseExpiry: yup.date().required("License Expiry Date is required"),
  npi: yup.string().required("NPI is required"),
  workExperience: yup.number().required("Work Experience is required"),
  agencyName: yup.string().required("Agency Name is required"),
  serviceName: yup.array().min(1, "At least one service must be selected"),
  serviceType: yup.string().required("Service Type is required"),
  lastAuditDate: yup.date().required("Last Audit Date is required"),
  auditResult: yup.string().required("Audit Result is required"),
  username: yup.string().required("Username is required"),
  password: yup.string().required("Password is required"),
  role: yup.string().required("Role is required"),
});

const ServiceCoordinatorRegistration = () => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      certifications: [{}],
      serviceName: [],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "certifications",
  });

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
       <div className="advance-search">
        <div className="search-header">
          <div className="title">
            <button className="" >
             Personal Information
            </button>
          </div>
        </div>

        <div className="search-body">
         <div className="row">
          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="First Name" name="firstName" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="Last Name" name="lastName" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="Date of Birth" name="dateOfBirth" type="date" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormSelect label="Gender" name="gender" options={["Male", "Female", "Other"]} register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="Phone Number" name="phoneNumber" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="Email" name="email" type="email" register={register} errors={errors} />
          </div>

           <hr style={{color:"blue", padding:"2px"}}/>
            <h6><strong>Contact Information</strong></h6>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="Address Line 1" name="addressLine1" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="Address Line 2" name="addressLine2" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="City" name="city" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="State" name="state" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="Zip Code" name="zipCode" register={register} errors={errors} />
          </div>


          {/* <hr style={{color:"blue", padding:"2px"}}/>
            <h6><strong>Professional Details</strong></h6>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="Employee ID" name="employeeId" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="License Number" name="licenseNumber" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="License Expiry Date" name="licenseExpiryDate" type="date" register={register} errors={errors} />
          </div>

          <div className="col-xl-4 col-lg-4 col-md-4 col-12">
            <FormInput label="NPI (National Provider Identifier)" name="npi" register={register} errors={errors} />
          </div> */}

         </div>
        </div>

       </div>

      <div className="advance-search">
       <div className="search-header">
        <div className="title">
          <button className="" >
          Certification Details
          </button>
        </div>

        <div className="search-button">
          <div className="search-icon  collapsed"  type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
          </div>
        </div>
       </div>

       {fields.map((item, index) => (
          <div className="search-body  accordion-collapse collapse" key={item.id} id="flush-collapseOne"  data-bs-parent="#accordionFlushExample">
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <FormInput label="Certification Name" name={`certifications[${index}].certificationName`} register={register} errors={errors} />
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <FormInput label="Issuing Organization" name={`certifications[${index}].issuingOrganization`} register={register} errors={errors} />
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <FormInput label="Issue Date" name={`certifications[${index}].issueDate`} type="date" register={register} errors={errors} />
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <FormInput label="Expiry Date" name={`certifications[${index}].expiryDate`} type="date" register={register} errors={errors} />
              </div>

              <div className="col-xl-4 col-lg-4 col-md-4 col-12">
                <FormInput label="Work Experience (Years)" name={`certifications[${index}].workExperience`} type="number" register={register} errors={errors} />
              </div>
            </div>

            <button type="button" className="button cancel" onClick={() => remove(index)}>Remove</button>
            <button button className="button save m-1" type="button" onClick={() => append({})}>Add Certification</button>
          </div>
        ))}

      </div>


      {/* <h4>Login & Access Control</h4>
      <div className="row">
        <FormInput label="Username" name="username" register={register} errors={errors} />
        <FormInput label="Password" name="password" type="password" register={register} errors={errors} />
        <FormSelect label="Role" name="role" options={["Admin", "Coordinator", "Staff"]} register={register} errors={errors} />
      </div> */}

       <div className="d-flex justify-content-center">
        <button type="submit" className="button save me-2"><i className="bi bi-send"></i> Submit</button>
        <button type="submit" className="button info me-2"><i className="bi bi-save"></i> Save as Draft</button>
        <button type="submit" className="button cancel"><i className="bi bi-x-lg"></i> Reset </button>
      </div>
    </form>
  );
};

export default ServiceCoordinatorRegistration;